import React from "react";
import "../style.css"; 
const TextCell  = ({value}) =>(
    <div className="table-text-cell" title={value}>
        {value}
    </div>
);

const BankNameCell = ({bankName}) =>(
    <div className="table-bank-cell" title={bankName}>
        {bankName}
    </div>
);


export const IFSC_MASTER_COLUMNS = [
    {
        Header:"Corporate ID",
        id:"corporateId",
        accessor: d => <TextCell value={d.corporateId}/> 
    },
     {
        Header:"IFSC Code",
        id:"ifscCode",
        accessor: d => <TextCell value={d.ifscCode}/> 
    },
      {
        Header:"Bank Name",
        id:"bankName",
        accessor: d => <TextCell value={d.bankName}/> 
    },
     {
        Header:"Branch Name",
        id:"branchName",
        accessor: d => <TextCell value={d.branchName}/> 
    },
     {
        Header:"GST",
        id:"branchGst",
        accessor: d => <TextCell value={d.branchGst}/> 
    },
     {
        Header:"State",
        id:"state",
        accessor: d => <TextCell value={d.state}/> 
    },
     {
        Header:"Sales Associate",
        id:"salesAssociate",
        accessor: d => <TextCell value={d.salesAssociate}/> 
    },
     {
        Header:"Regional Manager",
        id:"regionalManager",
        accessor: d => <TextCell value={d.regionalManager}/> 
    },
     {
        Header:"Region",
        id:"region",
        accessor: d => <TextCell value={d.region}/> 
    },
    {
        Header:"Local Party Billing",
        id:"localPartyBilling",
        accessor: d => <TextCell value={d.localPartyBilling}/> 
    }


]

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_NUMBER = 0;